<template lang="pug">
    v-dialog( v-model="dialog" max-width="500px")
        v-toolbar(dark='' color='primary')
            v-toolbar-title.white--text {{ title }}
            v-spacer
            v-btn(icon='' @click="dialog = !dialog ")
                v-icon close
        v-card
            v-container(fluid='')
                v-flex.text-xs-center.text-sm-center.text-md-center.text-lg-center(xs12='')
                    img(:src='imageUrl' height='100' v-if='imageFile')
                    v-text-field(label='Seleccione Archivo' @click='pickFile' v-model='fileName' prepend-icon='attach_file')
                    input(type='file' style='display: none' ref='image' accept='.csv' @change='onFilePicked')
                v-flex(md12)
                    v-btn(icon='' @click='confirmSubmit'  block flat   color="info")
                        v-icon link
                        |  subir Archivo

</template>

<script>
import axios from 'axios'
import API from '../../services/api/api.js'
import logo from './image/icon_csv.png'
import { mapActions, mapState } from 'vuex'
import AccountBankService from '@/services/api/accountBank'
export default {
    name: 'upload-file',
    //props: {},
    data: function() {
        return {
            title: 'Subir Archivo',
            fileName: '',
            imageUrl: logo,
            imageFile: '',
            dialog: false,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        /**
         * 
         */
        pickFile () {
            this.$refs.image.click ()
        },
		/**
         * 
         */
		onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.fileName = files[0].name
				if(this.fileName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					//this.imageUrl = fr.result
					this.imageFile = files[0]
				})
			} else {
				this.fileName = ''
				this.imageFile = ''
				//this.imageUrl = ''
			}
        },
        /**
         * 
         */
        async submitFile(){
            
            let formData = new FormData();
            formData.append('file', this.imageFile);
            let route = API.ACCOUNTING_BANK_CARD_VALIDATE
            let response = await AccountBankService.validate(route,formData)
            this.responseSubmit(response)
        },
        /**
         * 
         */
        confirmSubmit(){
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Subir cartola')
            this.initSnackbar(this.fillSnack('warning', 'Cartola','¿Estas seguro de subir la cartola seleccionada?'))
        },
        /**
         * 
         */
        responseSubmit (response) {
            let status = response.status
            switch (status) {
                case 200:
                    this.successResponse()
                    this.emitEvent(response)
                    this.closeDialog()
                    break;
                default:
                    this.errorResponse(response.response.data.message)
                    break;
            }
        },
        /**
         * 
         */
        successResponse () {
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('success','Éxito','Cartola subida exitosamente',false,3600))
        },
        /**
         * 
         */
        errorResponse(message) {
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('error','Error',message))
        },
        /**
         * 
         */
        waitingResponse() {
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('info','Subiendo','Cargando Cartola....',true))
        },
        /**
         *
         */
        emitEvent(response){
            const payload = response.data.records.records
            this.$emit('upload_accounting_bank', payload)
        },
        /**
         *
         */
        closeDialog(){
            this.dialog = false
        }       
    },
    watch: {
        responseConfirm(val){
            switch (val) {
                case 'Subir cartola':
                    this.waitingResponse()
                    this.submitFile()
                    break;            
                default:
                    break;
            }
        }
    },
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>